import Glide, { Breakpoints } from "@glidejs/glide";

document.addEventListener("DOMContentLoaded", () => {

  if (document.querySelector('.glide-timeline')) {
    const glideTimeline = new Glide('.glide-timeline', {
      type: "slider",
      perView: 5,
      focusAt: 'center',
      startAt: 3,
      gap: 24,
      rewind: false,
      breakpoints: {
        680: {
          perView:1,
        },

        1127: {
          perView:3,
        },
      }
    });
    glideTimeline.mount();
  }



  if (document.querySelector(".glide-languages")) {
    const glideLanguages = new Glide(".glide-languages", {
      type: "carousel",
      animationDuration: 800,
      gap: 40,
      perView: 4,
      rewind: false,
      breakpoints: {
        600: {
          perView: 1,
        },
        800: {
          perView: 2,
        },
        1000: {
          perView: 3,
        },
      }
    });

     const autoArrows = function (Glide, Components, Events) {
      const AutoArrows = {
        NAV_SELECTOR: '[data-arrows]',

        mount() {
          const arrowsWrapper =
            Components.Html.root.querySelector(this.NAV_SELECTOR);

          if (!arrowsWrapper) return;

          const [arrowLeft, arrowRight] =
            arrowsWrapper.querySelectorAll('button');

          arrowLeft.onclick = () => {
            const currentPage = Math.floor(
              Glide.index / Glide.settings.perView
            );

            Components.AutoBullets.navigateTo(currentPage - 1);
          };

          arrowRight.onclick = () => {
            const currentPage = Math.floor(
              Glide.index / Glide.settings.perView
            );

            Components.AutoBullets.navigateTo(currentPage + 1);
          };
        }
      };

      return AutoArrows;
    };

    const autoBullets = function (Glide, Components, Events) {
      const AutoBullets = {
        NAV_SELECTOR: '[data-glide-el="controls[nav]"]',

        mount() {
          this._nodes = [];

          const { perView } = Glide.settings;
          const totalPages = Math.ceil(
            Components.Html.slides.length / perView
          );

          this._prevPerView = perView;

          const bulletWrapper =
            Components.Html.root.querySelector(this.NAV_SELECTOR);

          if (!bulletWrapper) return;

          const fragment = document.createDocumentFragment();

          for (let index = 0; index < totalPages; index++) {
            const button = document.createElement('button');

            button.className = 'glide__bullet';
            button.setAttribute('data-index', index);
            button.setAttribute(
              'data-glide-dir',
              `=${index * perView}`
            );

            button.addEventListener('click', () => {
              this.navigateTo(index);
            });

            this._nodes.push(button);
            fragment.appendChild(button);
          }

          bulletWrapper.innerHTML = '';
          bulletWrapper.appendChild(fragment);

          this.setActive(0);
        },

        navigateTo(index) {
          const { perView } = Glide.settings;

          if (index > this._nodes.length - 1) {
            index = 0;
          }

          if (index < 0) {
            index = this._nodes.length - 1;
          }

          Glide.go(`=${index * perView}`);
          this.setActive(index);
        },

        setActive(index) {
          this._nodes.forEach((button, i) => {
            button.classList.toggle(
              'glide__bullet--active',
              i === index
            );
          });
        },

        updateActive() {
          const { perView } = Glide.settings;

          // Convert actual slide index to page index
          const page = Math.floor(Glide.index / perView);

          this.setActive(page);
        },

        reset() {
          const { perView } = Glide.settings;

          if (perView !== this._prevPerView) {
            Glide.go('<<');
            this.mount();
          }
        }
      };

      Events.on('run.after', () => {
        AutoBullets.updateActive();
      });

      Events.on('resize', () => {
        AutoBullets.reset();
      });

      return AutoBullets;
    };
    
    glideLanguages.mount({
      AutoArrows: autoArrows,
      AutoBullets: autoBullets
    });
  }
});